/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Total_ValueInputs */

const en_dashboard_total_value = /** @type {(inputs: Dashboard_Total_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total value`)
};

const pt_br2_dashboard_total_value = /** @type {(inputs: Dashboard_Total_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total`)
};

/**
* | output |
* | --- |
* | "Total value" |
*
* @param {Dashboard_Total_ValueInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_total_value = /** @type {((inputs?: Dashboard_Total_ValueInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Total_ValueInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_total_value(inputs)
	return pt_br2_dashboard_total_value(inputs)
});